// extracted by mini-css-extract-plugin
export default {"container":"Toasts-module__container--d9T0j"};